import { render, staticRenderFns } from "./EditReview.vue?vue&type=template&id=2aebe6a2&scoped=true&"
import script from "./EditReview.vue?vue&type=script&lang=js&"
export * from "./EditReview.vue?vue&type=script&lang=js&"
import style0 from "./EditReview.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EditReview.vue?vue&type=style&index=1&id=2aebe6a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aebe6a2",
  null
  
)

export default component.exports